function formatPhoneNumber(phone) {
    const phoneStr = phone.toString();
    const ddd = phoneStr.slice(0, 2);
    const part1 = phoneStr.slice(2, phoneStr.length - 4);
    const part2 = phoneStr.slice(-4);
    return `(${ddd}) ${part1}-${part2}`;
}

export const InformationOne = ({ project }) => {
    return (
        <section className="sl-information-section">
            <div className="sl-information-container sl-information-column-gap-default">
                <div className="sl-information-small-container">
                    <div>
                        <div className="sl-information-widget-container">
                            <h3 className="sl-information-heading-subtitle">
                                Horário de Funcionamento:{' '}
                            </h3>
                        </div>
                        <div className="sl-information-widget-container">
                            <p>
                                {project.time.length > 0 && project.all_time == '0' &&
                                    project.time.map((time) => {
                                        return (
                                            <>
                                                <strong>
                                                    {time.day.label}:
                                                </strong>{' '}
                                                {time.from_time} às{' '}
                                                {time.to_time}
                                                <br />
                                            </>
                                        );
                                    })}
                                {project.all_time == '1' &&
                                    <strong>
                                        Sempre aberto - 24 horas
                                    </strong>
                                }
                            </p>
                        </div>
                        <div></div>
                    </div>
                </div>
                <div className="sl-information-small-container">
                    <div className="sl-information-widget-wrap sl-information-element-populated">
                        <div className="sl-information-widget-container">
                            <h3 className="sl-information-heading-subtitle">
                                Contatos
                            </h3>
                        </div>
                        <div className="sl-information-widget-container">
                            <ul className="sl-information-icon-list-items">
                                <li className="sl-information-icon-list-item">
                                    <span className="sl-information-icon-list-icon">
                                        <svg
                                            aria-hidden="true"
                                            className="e-font-icon-svg e-fas-phone-alt"
                                            viewBox="0 0 512 512"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path d="M497.39 361.8l-112-48a24 24 0 0 0-28 6.9l-49.6 60.6A370.66 370.66 0 0 1 130.6 204.11l60.6-49.6a23.94 23.94 0 0 0 6.9-28l-48-112A24.16 24.16 0 0 0 122.6.61l-104 24A24 24 0 0 0 0 48c0 256.5 207.9 464 464 464a24 24 0 0 0 23.4-18.6l24-104a24.29 24.29 0 0 0-14.01-27.6z"></path>
                                        </svg>
                                    </span>
                                    <span className="sl-information-heading-subtitle">
                                        {project.phone.length > 9
                                            ? formatPhoneNumber(project.phone)
                                            : project.phone}
                                    </span>
                                </li>
                                <li className="sl-information-icon-list-item">
                                    <span className="sl-information-icon-list-icon">
                                        <svg
                                            aria-hidden="true"
                                            className="e-font-icon-svg e-fas-map-marker-alt"
                                            viewBox="0 0 384 512"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path d="M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0zM192 272c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80z"></path>
                                        </svg>
                                    </span>
                                    <span className="sl-information-heading-subtitle">
                                        {project.address &&
                                            [
                                                project.address.street_name,
                                                project.address.address_number,
                                                project.address.city,
                                                project.address.state
                                            ].join(', ')}
                                    </span>
                                </li>
                                <li className="sl-information-icon-list-item">
                                    <span className="sl-information-icon-list-icon">
                                        <svg
                                            aria-hidden="true"
                                            className="e-font-icon-svg e-fas-link"
                                            viewBox="0 0 512 512"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path d="M326.612 185.391c59.747 59.809 58.927 155.698.36 214.59-.11.12-.24.25-.36.37l-67.2 67.2c-59.27 59.27-155.699 59.262-214.96 0-59.27-59.26-59.27-155.7 0-214.96l37.106-37.106c9.84-9.84 26.786-3.3 27.294 10.606.648 17.722 3.826 35.527 9.69 52.721 1.986 5.822.567 12.262-3.783 16.612l-13.087 13.087c-28.026 28.026-28.905 73.66-1.155 101.96 28.024 28.579 74.086 28.749 102.325.51l67.2-67.19c28.191-28.191 28.073-73.757 0-101.83-3.701-3.694-7.429-6.564-10.341-8.569a16.037 16.037 0 0 1-6.947-12.606c-.396-10.567 3.348-21.456 11.698-29.806l21.054-21.055c5.521-5.521 14.182-6.199 20.584-1.731a152.482 152.482 0 0 1 20.522 17.197zM467.547 44.449c-59.261-59.262-155.69-59.27-214.96 0l-67.2 67.2c-.12.12-.25.25-.36.37-58.566 58.892-59.387 154.781.36 214.59a152.454 152.454 0 0 0 20.521 17.196c6.402 4.468 15.064 3.789 20.584-1.731l21.054-21.055c8.35-8.35 12.094-19.239 11.698-29.806a16.037 16.037 0 0 0-6.947-12.606c-2.912-2.005-6.64-4.875-10.341-8.569-28.073-28.073-28.191-73.639 0-101.83l67.2-67.19c28.239-28.239 74.3-28.069 102.325.51 27.75 28.3 26.872 73.934-1.155 101.96l-13.087 13.087c-4.35 4.35-5.769 10.79-3.783 16.612 5.864 17.194 9.042 34.999 9.69 52.721.509 13.906 17.454 20.446 27.294 10.606l37.106-37.106c59.271-59.259 59.271-155.699.001-214.959z"></path>
                                        </svg>
                                    </span>
                                    <span className="sl-information-heading-subtitle">
                                        {project.link}
                                    </span>
                                </li>
                                <li className="sl-information-icon-list-item">
                                    <span className="sl-information-icon-list-icon">
                                        <svg
                                            aria-hidden="true"
                                            className="e-font-icon-svg e-fas-envelope"
                                            viewBox="0 0 512 512"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path d="M502.3 190.8c3.9-3.1 9.7-.2 9.7 4.7V400c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V195.6c0-5 5.7-7.8 9.7-4.7 22.4 17.4 52.1 39.5 154.1 113.6 21.1 15.4 56.7 47.8 92.2 47.6 35.7.3 72-32.8 92.3-47.6 102-74.1 131.6-96.3 154-113.7zM256 320c23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7 5.8-4.5 9.2-11.5 9.2-18.9v-19c0-26.5-21.5-48-48-48H48C21.5 64 0 85.5 0 112v19c0 7.4 3.4 14.3 9.2 18.9 30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4z"></path>
                                        </svg>
                                    </span>
                                    <span className="sl-information-heading-subtitle">
                                        {project.email}
                                    </span>
                                </li>
                                <li className="sl-information-icon-list-item">
                                    <span className="sl-information-icon-list-icon">
                                        <svg
                                            aria-hidden="true"
                                            className="e-font-icon-svg e-fas-user"
                                            viewBox="0 0 448 512"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path d="M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"></path>
                                        </svg>
                                    </span>
                                    <span className="sl-information-heading-subtitle">
                                        Responsável: {project.responsible_name} - {project.responsible_role}
                                    </span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};
